import { Component, OnInit } from '@angular/core';
import { DialogBase } from '@routes/dialogs/dialog.base';
import Utils from '@shared/utils/utils';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MasterCode } from '@shared/enums/master-code';
import DateUtils from '@shared/utils/date-utils';
import Swal from 'sweetalert2';
import Roles from '@shared/constants/roles';
import { Company } from '@shared/enums/company';
import { finalize } from 'rxjs/operators';
import { Constants } from '@shared/constants/constants';
import { DatePipe } from '@angular/common';
import Role from '@shared/constants/role';
import { DealerContactEditComponent } from '@routes/dealers/dealer-contact-edit/dealer-contact-edit.component';

@Component({
  selector: 'app-dealer-edit',
  templateUrl: './dealer-edit.component.html',
  styleUrls: ['./dealer-edit.component.scss']
})
export class DealerEditComponent extends DialogBase implements OnInit {

  title: any;
  bpNo: any;
  buttonLabel: any;
  onboarding: any;
  showOnboarding: any;
  noReset: boolean = false;

  dealerInfo: any;
  addressData = {};

  detailForm: FormGroup;
  hqOptions = [];
  hqPurchasePlaceCodes = [];
  hqBpNos = [];
  statuses = [];
  requestStatus = [];
  bpTypes = [];
  concealedDamageTypes = [];
  error: any;
  isAdmin: false;

  labelHq = 'HQ BP #';
  placeHolderHq = 'Select HQ BP #';

  isHq: boolean = false;
  hqBpNo;
  country;
  company;
  companies = Company;
  pipe = new DatePipe('en-US');

  isDealer = false;
  hqSelected = false;
  verifiedBpNo;

  get form() {
    return this.detailForm.controls;
  }

  ngOnInit(): void {
    this.company = this.authService.getCurrentCompany();
    this.isAdmin = this.authService.hasType(Roles.dealerNewView);
    this.isDealer = this.authService.hasType(Roles.dealer);
    this.country = this.authService.getCurrentCountry(this.company);
    this.setFormControls();
    this.setSelectOptions();
    this.showOnboarding = false;
    this.title = [this.companies.Seca, this.companies.SeaIm].includes(this.company) ? 'Store' : this.title;
    if (this.dealerInfo) {
      if (this.onboarding) {
        this.setOnboarding();
      }
      if (this.dealerInfo?.noDirect) {
        this.noReset = true;
      }
      this.setEdit(this.dealerInfo);
    }
    if (!this.isAdmin) {
      this.disableFormControls();
    }
    this.title = this.company === this.companies.Seca && this.isDealer && !this.dealerInfo?.hq ? 'Store' : 'Dealer'
  }

  setFormControls() {
    if (this.bpNo) {
      this.detailForm = this.fb.group({
        bpNo: new FormControl({ value: null, disabled: true }),
        name: [null, Validators.compose([Validators.required])],
        hq: false,
        hqBpNo: null,
        concealedDamage: null,
        concealedDamageType: null,
        status: [null, Validators.required],
        mainContact: [null, Validators.compose([Validators.required, Validators.pattern(/^([2-9]{1}[0-9]{2}[2-9]{1}[0-9]{6})$/)])],
        mainEmail: [null, Validators.compose([Validators.required, Validators.email])],
        escalationEmail: [null, Validators.email],
        address: null,
        requestDate: new FormControl({ value: null, disabled: true }),
        reviewedDate: new FormControl({ value: null, disabled: true }),
        reviewedBy: new FormControl({ value: null, disabled: true }),
        rejectReason: null,
        requestStatus: new FormControl({ value: null, disabled: true }),
        firstName: null,
        lastName: null,
        contactTel: null,
        contactEmail: null,
        contactExt: null,
        distributorName: null,
      });
    } else if ([this.companies.SeaIm].includes(this.company)) {
      this.detailForm = this.fb.group({
        bpNo: [null, Validators.pattern(/^[5]{1}[0-9]{9}$/)],
        name: [null, Validators.compose([Validators.required])],
        hq: false,
        hqBpNo: null,
        concealedDamage: null,
        concealedDamageType: null,
        status: null,
        mainContact: [null, Validators.compose([Validators.required, Validators.pattern(/^([2-9]{1}[0-9]{2}[2-9]{1}[0-9]{6})$/)])],
        mainEmail: [null, Validators.compose([Validators.required, Validators.email])],
        escalationEmail: [null, Validators.email],
        address: null,
        requestDate: new FormControl({ value: null, disabled: true }),
        reviewedDate: new FormControl({ value: null, disabled: true }),
        reviewedBy: new FormControl({ value: null, disabled: true }),
        rejectReason: null,
        requestStatus: new FormControl({ value: null, disabled: true }),
        firstName: [null, Validators.required],
        lastName: [null, Validators.required],
        contactTel: [null, Validators.compose([Validators.required, Validators.pattern(/^([2-9]{1}[0-9]{2}[2-9]{1}[0-9]{6})$/)])],
        contactEmail: [null, Validators.compose([Validators.required, Validators.email])],
        contactExt: null,
        distributorName: new FormControl({ value: null, disabled: true }),
      });
    } else {
      this.detailForm = this.fb.group({
        bpNo: [null, Validators.pattern(/^[5]{1}[0-9]{9}$/)],
        name: [null, Validators.compose([Validators.required])],
        hq: false,
        hqBpNo: null,
        concealedDamage: null,
        concealedDamageType: null,
        status: null,
        mainContact: [null, Validators.compose([Validators.required, Validators.pattern(/^([2-9]{1}[0-9]{2}[2-9]{1}[0-9]{6})$/)])],
        mainEmail: [null, Validators.compose([Validators.required, Validators.email])],
        escalationEmail: [null, Validators.email],
        address: null,
        requestDate: new FormControl({ value: null, disabled: true }),
        reviewedDate: new FormControl({ value: null, disabled: true }),
        reviewedBy: new FormControl({ value: null, disabled: true }),
        rejectReason: null,
        requestStatus: new FormControl({ value: null, disabled: true }),
        firstName: [null, Validators.required],
        lastName: [null, Validators.required],
        contactTel: [null, Validators.compose([Validators.pattern(/^([2-9]{1}[0-9]{2}[2-9]{1}[0-9]{6})$/)])],
        contactEmail: [null, Validators.compose([Validators.required, Validators.email])],
        contactExt: null,
        distributorName: new FormControl({ value: null, disabled: true }),
      });
    }
  }

  disableFormControls() {
    const targetFields = ['hq', 'concealedDamage', 'status'];
    this.setFormControlDisable(this.form, targetFields);
  }

  setFormControlDisable(form, controls) {
    return controls.forEach(control => {
      form[control].disable();
    });
  }

  setSelectOptions() {
    this.apiService.master.getConstant(MasterCode.DealerStatus).subscribe(res => {
      let arr = [];
      Object.keys(res).map(function (key) {
        if (key !== 'REQUESTED') {
          arr.push({ ['code']: res[key], ['name']: res[key] })
        }
        return arr;
      });
      this.statuses = arr;
    });

    this.apiService.master.getConstant(MasterCode.DealerRequestStatus).subscribe(res => {
      let arr = [];
      Object.keys(res).map(function (key) {
        arr.push({ ['code']: res[key], ['name']: res[key] })
        return arr;
      });
      this.requestStatus = arr;
    });

    this.apiService.master.getConstant(MasterCode.DealerBpTypes).subscribe(res => {
      this.bpTypes = res;
    });

    this.apiService.master.getConstant(MasterCode.ConcealedDamageTypes).subscribe(res => {
      this.concealedDamageTypes = res;
    });

    this.hqBpNos = this.authService.getHQDealers()?.map(c => {
      return {
        code: c.bpNo,
        name: c.name
      }
    });

    this.apiService.purchasePlace.getPurchasePlaceCodes().subscribe(rs => {
      this.hqPurchasePlaceCodes = rs?.sort((p1, p2) => p1.displayOrder > p2.displayOrder ? 1 : -1);
      this.hqOptions = this.hqBpNos;
      this.setHqOptions(undefined, this.dealerInfo?.hq);
    });

    if (!this.isAdmin) {
      this.isHq = false;
      this.hqBpNo = this.hqBpNos[0]?.code;
    }
  }

  submitForm($event) {
    $event.stopPropagation();
    $event.preventDefault();
    let dealerData = this.detailForm.getRawValue();
    dealerData = this.valueRedefinition(dealerData);
    if (this.detailForm.invalid || this.googlePlacesAutocomplete.validAddress(dealerData.address)) {
      this.googlePlacesAutocomplete.isAddressValid$.next(true);
      this.detailForm.markAllAsTouched();
      return;
    }
    this.googlePlacesAutocomplete.isAddressValid$.next(false);

    const company = this.authService.getCurrentCompany();
    const tel = dealerData.mainContact;
    const email = dealerData.mainEmail;
    const firstName = dealerData.contactTel;

    let hq = dealerData.hq;
    let hqBpNo = '';
    let purchasePlaceCode = '';
    let status = dealerData.status;
    if (!this.bpNo) {
      if ([this.companies.Sea].includes(this.company) && !hq) {
        status = Constants.dealerStatus.ACTIVE.code;
      }
      if ([this.companies.SeaIm].includes(this.company)) {
        status = Constants.dealerStatus.ACTIVE.code;
        hq = true;
      }
      if ([this.companies.Seca].includes(this.company)) {
        if (this.isDealer) {
          status = Constants.dealerStatus.REQUESTED.code;
          hq = false;
        } else if (this.isAdmin) {
          status = Constants.dealerStatus.ACTIVE.code;
        }
      }
    }

    if (hq) {
      hqBpNo = '';
      if ([this.companies.Seca, this.companies.Sea].includes(this.company) && !dealerData.hqBpNo) {
        this.form['hqBpNo'].setErrors({ required: true });
        this.detailForm.markAllAsTouched();
        return;
      }
      purchasePlaceCode = dealerData.hqBpNo;
      this.hqSelected = true;
    } else {
      hqBpNo = dealerData.hqBpNo || this.hqBpNo;
      purchasePlaceCode = '';
      this.hqSelected = false;
    }
    dealerData.hq = hq;
    dealerData.hqBpNo = hqBpNo;
    dealerData.purchasePlaceCode = purchasePlaceCode;
    dealerData.status = status;
    dealerData = {
      ...dealerData,
      company,
      tel,
      email,
    }

    this.spinnerService.start();
    if (this.bpNo) {
      this.apiService.dealer.updateDealer(this.bpNo, dealerData)
        .pipe(finalize(() => this.spinnerService.stop()))
        .subscribe(res => {
          try {
            this.updateCdStoreRole(res);
          } catch (e) {
          }
          Swal.fire({
            title: 'Dealer Updated',
            text: 'Dealer updated successfully.',
            icon: 'success',
            allowOutsideClick: false,
          }).then((result) => {
            this.onClose.next(res);
            this.bsModalRef.hide();
          });
        }, err => Utils.showError(err));
    } else {
      const message = [this.companies.Seca].includes(this.company) && this.isDealer ?
        'Request Successfully' : 'Dealer created successfully.'
      this.apiService.dealer.createDealer(dealerData)
        .pipe(finalize(() => this.spinnerService.stop()))
        .subscribe(res => {
          Swal.fire({
            title: [this.companies.SeaIm].includes(this.company) ? 'Account Created' : 'Dealer Created',
            text: message,
            icon: 'success',
            allowOutsideClick: false,
          }).then((result) => {
            this.onClose.next(res);
            this.bsModalRef.hide();
          });
        }, err => Utils.showError(err));
    }
  }

  updateCdStoreRole(res) {
    res.contacts.map(contact => this.apiService.user.getUser(contact.email).subscribe(userData => {
      let userDataInput = {
        firstName: userData.firstName,
        lastName: userData.lastName,
        username: userData.username,
        roles: userData.roles,
        userType: userData.userType,
        status: userData.status,
        organization: userData.organization,
        _id: userData._id,
        tel: userData.tel,
        email: userData.username,
        updatedAt: this.pipe.transform(userData.auth.updatedAt, 'shortDate'),
        createdAt: this.pipe.transform(userData.auth.createdAt, 'shortDate'),
      };

      if ([this.companies.Sea].includes(this.company)) {
        if (res.concealedDamageType !== Constants.concealedTypeType.NOT_ELIGIBLE.code) {
          userDataInput.roles.map(role => {
            if (role.company === this.company) {
              if (!role.groups.includes(Role.concealedDamageStore)) {
                role.groups.push(Role.concealedDamageStore);
              }
            }
          })
        } else {
          userData.roles.map(role => {
            if (role.company === this.company) {
              role.groups = role.groups.filter(item => item !== Role.concealedDamageStore);
            }
          })
        }
      }

      this.apiService.user.saveUser(userDataInput).subscribe();
    }));
  }

  valueRedefinition(value) {
    value = {
      ...value, address: {
        address1: (document.getElementById('edit_route') as HTMLInputElement).value,
        address2: (document.getElementById('edit_address2') as HTMLInputElement).value,
        city: (document.getElementById('edit_locality') as HTMLInputElement).value,
        state: (document.getElementById('edit_administrative_area_level_1') as HTMLInputElement).value,
        zipcode: (document.getElementById('edit_postal_code') as HTMLInputElement).value,
        country: (document.getElementById('edit_country') as HTMLInputElement).value,
      }
    };
    return value;
  }

  updateRequestStatus($event, result) {
    $event.stopPropagation();
    $event.preventDefault();
    this.spinnerService.start();
    let dealerData = this.detailForm.getRawValue();

    const onboarding = {
      bpNo: this.bpNo,
      purchasePlaceCode: dealerData.hqBpNo,
      concealedDamageType: dealerData.concealedDamageType,
      onboarding: {
        requestDate: this.onboarding.requestDate,
        reviewedDate: new Date(),
        rejectReason: dealerData.rejectReason,
        status: result,
      },
    };
    console.log('onboarding =', onboarding);
    const title = result === 'ACCEPTED' ? 'Accepted' : 'Rejected';
    const description = result === 'ACCEPTED' ? 'Accepted Successfully' : 'Rejected Successfully';
    this.apiService.dealer.updateRequestStatus(dealerData.bpNo, onboarding)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        Swal.fire({
          title: title,
          text: description,
          icon: 'success',
          allowOutsideClick: false,
        }).then((result) => {
          this.onClose.next(null);
          this.bsModalRef.hide();
        });
      }, err => Utils.showError(err));

  }

  deleteRequestedDealer() {
    if (this.dealerInfo.bpNo) {
      Swal.fire({
        title: 'Are you sure to delete the Dealer?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        icon: 'question',
      }).then((result) => {
        if (result.isConfirmed) {
          this.apiService.dealer.deleteRequestedDealer(this.dealerInfo.bpNo)
            .subscribe(res => {
              Swal.fire('Deleted!', '', 'success');
              this.onClose.next();
              this.bsModalRef.hide();
              // this.dealerDetail = res;
            }, err => Utils.showError(err));
        } else if (result.isDenied) {
          Swal.fire('Canceled!', '', 'info');
        }
      });
    }
  }

  setHqOptions(event?, isChecked?) {
    console.log('isChecked =', isChecked);
    if ([this.companies.SeaIm].includes(this.company)) {
      return;
    }
    let checked;

    if (event) {
      checked = event.target.checked;
    } else {
      checked = isChecked || false;
    }
    this.hqSelected = checked;
    if ([this.companies.Sea, this.companies.Seca].includes(this.company)) {
      if (checked) {
        this.labelHq = [this.companies.Seca].includes(this.company) ? 'Purchase Place' : 'Dealer Code';
        this.placeHolderHq = [this.companies.Seca].includes(this.company) ? 'Select Purchase Place' : 'Select Dealer Code';
        this.hqOptions = this.hqPurchasePlaceCodes;
      } else {
        this.labelHq = 'HQ BP#';
        this.placeHolderHq = 'Select HQ BP #';
        this.hqOptions = this.hqBpNos;
      }
    } else {
      this.labelHq = 'HQ BP#';
      this.placeHolderHq = 'Select HQ BP #';
      this.hqOptions = this.hqBpNos;
      if (checked) {
        this.form['hqBpNo'].disable();
      } else {
        this.form['hqBpNo'].enable();
      }
    }
  }

  checkEmail(target, $event) {
    const bpNo = this.dealerInfo?.bpNo;
    const emailValue = $event.target.value;
    if (emailValue) {
      if (target === 'mainEmail') {
        this.apiService.dealer.checkDuplicateEmail(emailValue, bpNo)
          .subscribe(res => {
          }, err => {
            Utils.showError(err);
            this.form[target].setValue(null);
          });
      }
      if (target === 'contactEmail') {
        this.apiService.user.checkDuplicateEmail(emailValue)
          .subscribe(res => {
          }, err => {
            Utils.showError(err);
            this.form[target].setValue(null);
          });
      }
    }
  }

  checkBpNo($event) {
    const bpNo = $event.target.value;
    if (bpNo) {

      this.apiService.dealer.checkValidBpNo(bpNo)
        .subscribe(res => {
          this.verifiedBpNo = res;
        }, err => {
          Utils.showError(err);
          this.form['bpNo'].setValue(null);
        });
    }
  }

  openAddUserModal() {
    let dealerData = this.detailForm.getRawValue();
    dealerData = this.valueRedefinition(dealerData);
    const contactDetail = {
      email: dealerData.contactEmail,
      tel: dealerData.contactTel,
      firstName: dealerData.firstName,
      lastName: dealerData.lastName,
      ext: dealerData.contactExt,
      role: null,
      stores: null,
    }

    const initialState = {
      title: 'Contact Information',
      showDealerList: true,
      newContactInfo: contactDetail,
      buttonLabel: 'Create',
    };

    this.bsModalRef.hide();
    this.bsModalRef = this.modalService.show(DealerContactEditComponent, { initialState, class: 'modal-lg' });
    this.bsModalRef.content.onClose.subscribe(result => {
      if (result) {
        this.apiService.dealer.deleteRequestedDealer(this.dealerInfo.bpNo)
          .subscribe(() => {
            this.onClose.next();
            this.bsModalRef.hide();
          }, err => Utils.showError(err));
      }
    });
  }

  openAddStoreModal() {
    const newOptions = {
      diableList: ['hq', 'mainEmail', 'mainContact', 'name', 'firstName', 'lastName', 'contactTel', 'contactEmail', 'contactExt', 'escalationEmail'],
      hq: false,
      contacts: this.dealerInfo.contacts,
      name: this.dealerInfo.name,
      tel: this.dealerInfo.tel,
      email: this.dealerInfo.email,
      address: this.dealerInfo.address,
      onboarding: true,
      noDirect: true,
    }
    const initialState = {
      id: 1, title: 'Dealer Create', buttonLabel: 'Create', dealerInfo: newOptions,
    };

    this.bsModalRef.hide();
    this.bsModalRef = this.modalService.show(DealerEditComponent, { initialState, class: 'modal-lg' })
    this.bsModalRef.content.onClose.subscribe(result => {
      if (result) {
        this.apiService.dealer.deleteRequestedDealer(this.dealerInfo.bpNo)
          .subscribe(() => {
            this.onClose.next();
            this.bsModalRef.hide();
          }, err => Utils.showError(err));
      }
    });
  }

  private setEdit(detailInfo) {
    const form = this.detailForm.controls;
    Object.keys(form).forEach(key => {
      form[key].setValue(detailInfo[key]);
      if (key === 'address') {
        this.addressData = {
          address: detailInfo[key]
        };
      }
      if (key === 'mainEmail') {
        form[key].setValue(detailInfo.email);
      }
      if (key === 'mainContact') {
        form[key].setValue(detailInfo.tel);
      }
      if (key === 'firstName') {
        form[key].setValue(detailInfo.contacts[0]?.firstName);
      }
      if (key === 'lastName') {
        form[key].setValue(detailInfo.contacts[0]?.lastName);
      }
      if (key === 'contactTel') {
        form[key].setValue(detailInfo.contacts[0]?.tel);
      }
      if (key === 'contactExt') {
        form[key].setValue(detailInfo.contacts[0]?.ext);
      }
      if (key === 'contactEmail') {
        form[key].setValue(detailInfo.contacts[0]?.email);
      }
      if (key === 'hqBpNo') {
        if (detailInfo.hq) {
          form[key].setValue(detailInfo.purchasePlaceCode);
        } else {
          form[key].setValue(detailInfo.hqBpNo);
        }
      }
      // Onboarding Information
      if (detailInfo.onboarding) {
        if (key === 'requestDate') {
          form[key].setValue(DateUtils.utc2HQDate(detailInfo.onboarding.requestDate));
        }
        if (key === 'reviewedDate') {
          form[key].setValue(DateUtils.utc2HQDateTime(detailInfo.onboarding.reviewedDate));
        }
        if (key === 'rejectReason') {
          form[key].setValue(detailInfo.onboarding.rejectReason);
        }
        if (key === 'reviewedBy') {
          form[key].setValue(detailInfo.onboarding.reviewedBy);
        }
        if (key === 'requestStatus') {
          form[key].setValue(detailInfo.onboarding.status);
        }
      }
      console.log('this.showOnboarding =', this.showOnboarding);

      if (this.showOnboarding) {
        if (!['rejectReason', 'hqBpNo', 'concealedDamageType', 'concealedDamage', 'status'].includes(key)) {
          form[key].disable();
        }
      }

      if (this.dealerInfo.diableList) {
        this.dealerInfo.diableList.map(item => {
          form[item].disable();
        })
      }
    });
  }

  private setOnboarding() {
    this.showOnboarding = true;
    this.noReset = true;
  }
}
